import React, { useContext, Fragment } from 'react'
import Grid from '@material-ui/core/Grid'
import { Typography } from '@material-ui/core'
import { actions } from '../../store'
import SpinButton from '../SpinButton'
import { Context, stepStatusMap } from './SimulateMatchDialog'

const Team = ({ match, side }) => {
  const teamId = match[`${side}TeamId`]
  const teamName = match[`${side}Team`].name
  const status = match[`${side}Status`]
  const started = stepStatusMap.slice(2).includes(status)
  const { loading } = useContext(Context)

  const handleToggle = async () => {
    const data = {
      matchId: match.id,
      teamId,
      payload: { start: !started },
    }

    await actions.simulateMatch('start', data)
  }

  return (
    <Fragment>
      <Typography variant="body2" gutterBottom>{teamName}</Typography>
      <SpinButton
        size="small"
        color="primary"
        variant="contained"
        disabled={loading}
        loading={loading}
        onClick={handleToggle}
      >
        {started ? 'Un-start' : 'Start'}
      </SpinButton>
    </Fragment>
  )
}

const Start = ({ className, match }) => (
  <Grid container className={className} spacing={16}>
    <Grid item xs={12} md={6}>
      <Team side='home' match={match} />
    </Grid>
    <Grid item xs={12} md={6}>
      <Team side='away' match={match} />
    </Grid>
  </Grid>
)

export default Start
